import axios from 'axios';

export default function putBranchWhiteLabel({
  id,
  whiteLabel,
}) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/node/${id}/white-label`,
      {
        id,
        white_label: whiteLabel,
      })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.response.data)));
}
